import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { CreateNewMeasure, MeasuerOldOtherOdcValidation, resetCreationNewStatus, resetCreationStatus } from "../dataService/slice"
import { CustomerAddOtherOdcMeasueres } from "./form"

export function AddNewCodexMeasureOtherOdc() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const OtherOdcMeasuresState = useAppSelector(state => state.OtherOdcMeasuresState)
    const sessionState = useAppSelector(state => state.session)
    const [selectMeasureType, setSelectMeasureType] = useState<'old' | 'new'>()
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (OtherOdcMeasuresState.OtherOdcMeasuresCreationStatus === 'successfully') {
            dispatch(resetCreationStatus()); setShowSuccess(true)
        }
    }, [OtherOdcMeasuresState.OtherOdcMeasuresCreationStatus])

    useEffect(() => {
        if (OtherOdcMeasuresState.OtherOdcNewMeasuresCreationStatus === 'successfully') {
            dispatch(resetCreationNewStatus()); setShowSuccess(true)
        }
    }, [OtherOdcMeasuresState.OtherOdcNewMeasuresCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => { setShowSuccess(false); navigate('/provvedimentiCliente') }, 2000)
        }
    }, [showSuccess])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Nuovo Provvedimento Altro Odc']}
            headerLabel="Nuovo Provvedimento Altro OdC"
            customerName={sessionState.selected.customerName ?? undefined}
            customerCode={sessionState.selected.customerCode ?? undefined}
            rightBar={true}
            headerIcon={<ArrowLeftIcon onClick={() => navigate('/provvedimentiCliente')} color={colors.white} />}
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            if (selectMeasureType === 'old') dispatch(MeasuerOldOtherOdcValidation(OtherOdcMeasuresState.OtherOdcMeasuresCreationUpdate))
                            if (selectMeasureType === 'new') dispatch(CreateNewMeasure(OtherOdcMeasuresState.OtherOdcNewMeasuresCreationUpdate))
                        }}
                    />
                </div>
            }
        >
            {showSuccess && (
                <div className="mx-6 mt-6 rounded-xl border-2 border-green-300 bg-green-50 px-6 py-4">
                    <span className="text-sm font-semibold text-green-700">Dati salvati correttamente.</span>
                </div>
            )}
            <div className="flex flex-col gap-6 p-6">
                <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                    <div className="bg-brandPrimary-600 px-6 py-4">
                        <span className="text-white font-semibold text-lg">Provvedimenti </span>
                        <span className="text-brandPrimary-300">/</span>
                        <span className="text-brandPrimary-100 font-semibold"> Modalità di Inserimento</span>
                    </div>
                    <div className="p-6">
                        <MadfarmStaticSelect
                            disabled={!!selectMeasureType}
                            placeholder="Seleziona modalità..."
                            options={[
                                { value: 'new', label: 'Provvedimento (DM n.0323651 del 18/07/2024)' },
                                { value: 'old', label: 'Provvedimento (DM n.15962 del 20/12/2013)' },
                            ]}
                            onChange={(value) => {
                                //@ts-ignore
                                if (value?.value) setSelectMeasureType(value.value as 'old' | 'new')
                            }}
                            noOptionsMessage={""}
                            value={selectMeasureType}
                        />
                    </div>
                </div>
                {selectMeasureType && <CustomerAddOtherOdcMeasueres measureType={selectMeasureType} />}
            </div>
        </Layout>
    )
}